var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Card", {
        scopedSlots: _vm._u([
          {
            key: "head",
            fn: function () {
              return [
                _c("h5", [
                  _vm._v("\n                Upload manuscript "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        "font-size": "16px",
                        margin: "0",
                      },
                    },
                    [_vm._v("*")]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "main",
            fn: function () {
              return [
                _c("b-alert", { attrs: { show: "", variant: "primary" } }, [
                  _c("i", { staticClass: "fas fa-info-circle" }),
                  _vm._v(" File should be a Microsoft Word "),
                  _c("strong", [_vm._v("(.doc/.docx)")]),
                  _vm._v(" format. See the exmpale of "),
                  _c("strong", [_c("a", [_vm._v("Manuscript.docx")])]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Just upload your manuscript file and we will attempt to pre-populate the next steps as best we can."
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "file" },
                  on: {
                    change: function ($event) {
                      return _vm.upload($event)
                    },
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h6", [_vm._v("We’re parsing your manuscript…")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("ul", { staticClass: "parse-manuscript" }, [
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for manuscript title"
                          ),
                          _c("b", [
                            _vm._v(" - Identified as  and prepopulated."),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for authors (ORCIDs)"
                          ),
                          _c("b", [
                            _vm._v(
                              " - Out of total authors found and prepopulated."
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for abstract"
                          ),
                          _c("b", [_vm._v(" -  word abstract found ")]),
                          _vm._v(">\n                            "),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for keywords"
                          ),
                          _c("b", [_vm._v(" -  keywords found.")]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("ul", { staticClass: "parse-manuscript" }, [
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for keywords "
                          ),
                          _c("b", [_vm._v(" - 5 keywords found")]),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for manuscript body "
                          ),
                          _c("b", [_vm._v(" - 4500 words found")]),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "fas fa-check-circle" }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/public/images/utilities/spinner.svg",
                            },
                          }),
                          _vm._v(
                            "\n                                Looking for reviewers based on references and keywords "
                          ),
                          _c("b", [
                            _vm._v(" - 4 reviewers found and prepopulated"),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }